<template>
  <div>
    <button
      :aria-label="section.title"
      @click="setActiveItem('notification')"
    >
      <v-lazy-image
        :src="section.icon.source"
        :alt="section.icon.alt"
        width="24"
        height="24"
      />
      <counter
        v-if="count > 0"
        :show-number="false"
        @created="offersVisible"
      />
    </button>

    <pre-header-flyout
      v-if="preHeaderOpenItems.notification"
      class="offers"
      @closeFlyout="closeFlyout"
    >
      <header-offers
        :offers="section.offers"
        @updateCount="setNotificationCount"
      />
    </pre-header-flyout>
  </div>
</template>

<script>
  import VLazyImage from 'v-lazy-image'
  import gtmOffers from 'services/AirBaltic/GTM/Offers'
  import CookieUtils from 'utils/CookieUtils'
  import difference from 'lodash-es/difference'
  import { mapState } from 'vuex'

  const PreHeaderFlyout = () =>
    import(
      /* webpackChunkName: "pre-header-flyout" */ 'components/Header/White/PreHeader/PreHeaderFlyout'
    )
  const HeaderOffers = () =>
    import(
      /* webpackChunkName: "storyblok-header-offers" */ 'components/Storyblok/Header/HeaderOffers.vue'
    )
  const Counter = () => import(/* webpackChunkName: "counter" */ 'components/Counter')

  export default {
    components: {
      VLazyImage,
      Counter,
      HeaderOffers,
      PreHeaderFlyout
    },
    props: {
      section: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        count: this.notificationCount()
      }
    },
    computed: {
      ...mapState('header', ['preHeaderOpenItems'])
    },
    watch: {
      section() {
        this.setNotificationCount()
      }
    },
    methods: {
      notificationCount() {
        const notificationCookie = CookieUtils.getCookie('notificationsAlerts').split(',')

        if (this.section.offers.length === 0) {
          return 0
        }

        const notifications = this.section.offers.flatMap((item) => item.key)

        return difference(notifications, notificationCookie).length
      },
      offersVisible() {
        gtmOffers.offersVisible(this.count)
      },
      offersClicked() {
        gtmOffers.offersClicked(this.count)
      },
      setNotificationCount() {
        this.count = this.notificationCount()
      },
      setActiveItem(key) {
        if (this.preHeaderOpenItems[key]) {
          this.closeFlyout()
          return
        }

        this.offersClicked()
        this.$store.dispatch('header/openPreHeaderItem', key)
        this.$emit('show-backdrop')
      },
      closeFlyout() {
        this.$emit('close-backdrop')
      }
    }
  }
</script>

<style
  lang="scss"
  rel="stylesheet/scss"
  scoped
>
  @import '~assets/styles/common.scss';

  button {
    padding: 0;
    width: 40px;
    height: 40px;
    position: relative;

    .counter {
      top: 6px;
      right: 7px;
    }
  }

  ::v-deep .pre-header-flyout {
    @include bp-mf-tablet {
      top: 40px !important;
      left: auto !important;
      right: -56px !important;
    }

    @include bp-mf-desktop {
      top: 40px !important;
      left: calc(50% - 70px) !important;
      right: auto !important;
    }
  }
</style>
